import { render, staticRenderFns } from "./DashboardServiceFeedback.vue?vue&type=template&id=27cd5ba3&scoped=true"
import script from "./DashboardServiceFeedback.vue?vue&type=script&lang=js"
export * from "./DashboardServiceFeedback.vue?vue&type=script&lang=js"
import style0 from "./DashboardServiceFeedback.vue?vue&type=style&index=0&id=27cd5ba3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cd5ba3",
  null
  
)

export default component.exports